import { render, staticRenderFns } from "./DomesticLetters.vue?vue&type=template&id=66f78e2a&scoped=true"
import script from "./DomesticLetters.vue?vue&type=script&lang=js"
export * from "./DomesticLetters.vue?vue&type=script&lang=js"
import style0 from "./DomesticLetters.vue?vue&type=style&index=0&id=66f78e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f78e2a",
  null
  
)

export default component.exports